/* eslint-disable no-param-reassign */
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Section from 'modules/common/components/Section';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { customStyle } from 'helper';
import NewBusinessActivityList from './components/new-business-activity/NewBusinessActivityList';
import * as c from '../../constant';
import * as actions from '../../actions';
import UpdateLocation from './UpdateLocation';
// import BusinessActivityList from '../../components/BusinessActivityList';
import PreviousLocation from './PreviousLocation';
import ExistingBusinessActivityList from './components/existing-business-activity/ExistingBusinessActivityList';

function ChangeRequestModal({
  changeApplication,
  id,
  history,
  getItem,
  getRegionsList,
  regionsList,
  getProvinceList,
  provinceList,
  getMunicipalityList,
  municipalityList,
  getBarangayList,
  barangayList,
  updating,
  updateList,

  getVetRegistrationList,
  // vetRegistrationList,

  closeModal,
}) {
  const [formData, setFormData] = useState({
    area: '',
    base_line: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
    region_code: '',
    province_code: '',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    // dti_no: '',
    sec_no: '',
    // cda_no: '',
    monthly_rental: '',
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '',
    main_office_province_code: '',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    pin_selected: false,
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    // calculation_details: {},
    activities: '',
    existing_activities: '',
  });

  const business = _.get(updateList, 'included.bplsChangeRequests.attributes');
  const bplsActivities = _.get(updateList, "included.bplsChangeRequests.attributes.activities");
  const bplsExistingActivities = _.get(updateList, "included.bplsChangeRequests.attributes.existing_activities");
  // previous
  const businessPrevious = _.get(updateList, 'included.bplsBusiness.attributes');
  const bplsActivitiesPrevious = _.get(updateList, "included.bplsBusinessActivities");

  const [formDataPrevious, setFormDataPrevious] = useState({
    area: '',
    base_line: '',
    no_of_male_employees: 0,
    no_of_female_employees: 0,
    no_of_employees: 0,
    no_of_employees_residing_manila: 0,
    no_of_van: 0,
    no_of_truck: 0,
    no_of_motorcycle: 0,
    region_code: '',
    province_code: '',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    // dti_no: '',
    sec_no: '',
    // cda_no: '',
    monthly_rental: '',
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '',
    main_office_province_code: '',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    pin_selected: false,
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    activities: '',
    existing_activities: '',
  });

  // const [formDataCalculation, setFormDataCalculation] = useState({});
  // const [calculateData, setCalculateData] = useState({});

  const validateForm = useFormValidator(formData, {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required',
    // tin_no: 'required|tin_no',
    // dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|dti_no',
    // sec_no: 'required_if:kind_of_ownership=CORPORATION|sec_no',
    // cda_no: 'required_if:kind_of_ownership=COOPERATIVE|cda_no',

    // dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|max_30_char',
    // sec_no: "required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|sec_no",
    // sec_no:
    // 'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|max_30_char',
    // cda_no: "required_if:kind_of_ownership=COOPERATIVE|cda_no",
    // cda_no: 'required_if:kind_of_ownership=COOPERATIVE|max_30_char',

    // cellphone_no: 'required|cellphone_number',
    // telephone_no: 'required|tel_number',
    telephone_no: 'tel_number',
    // email_address: 'required|email',
    // municipality_code: 'required',
    // barangay_code: 'required',
    // street: 'required',
    // zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    // nationality:
    // 'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    // base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    // no_of_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_street: 'required',
    main_office_zip_code: 'required|number',
    // location_owned: 'required',
    lessor_name: 'required_if:location_owned=0',
    monthly_rental: 'required_if:location_owned=0',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
  });

  // const validateCalculation = Object.keys(formDataCalculation)
  //   .map(item => {
  //     return { [item]: 'required|number' };
  //   })
  //   .values();

  // const setValidateCalculation = () => {
  //   // eslint-disable-next-line no-restricted-syntax
  //   for (const value of validateCalculation) {
  //     setCalculateData(prevData => ({
  //       ...prevData,
  //       ...value,
  //     }));
  //   }
  // };

  // useEffect(() => {
  //   setValidateCalculation();
  // }, [formDataCalculation]);

  // const validateFormCalculation = useFormValidator(
  //   formDataCalculation,
  //   calculateData
  // );

  // useEffect(() => {
  //   validateFormCalculation.onSetObjectRules(calculateData);
  // }, [formDataCalculation]);

  const setModal = useContext(ModalContext);
  const addressListPrevious = _.get(updateList, 'included.bplsBusiness.attributes');

  const [mainOfficeRegionPrevious,] = useState({
    label: _.get(addressListPrevious, 'main_office_region_name'),
    value: _.get(addressListPrevious, 'main_office_region_code'),
  });

  const [mainOfficeProvincePrevious,] = useState({
    label: _.get(addressListPrevious, 'main_office_province_name'),
    value: _.get(addressListPrevious, 'main_office_province_code'),
  });

  const [mainOfficeMunicipalityPrevious,] = useState({
    label: _.get(addressListPrevious, 'main_office_municipality_name'),
    value: _.get(addressListPrevious, 'main_office_municipality_code'),
  });

  const [mainOfficeBarangayPrevious,] = useState({
    label: _.get(addressListPrevious, 'main_office_barangay_name'),
    value: _.get(addressListPrevious, 'main_office_barangay_code'),
  });

  const addressList = _.get(updateList, 'included.bplsChangeRequests.attributes');

  const [mainOfficeRegion, setMainOfficeRegion] = useState({
    label: _.get(addressList, 'main_office_region_name'),
    value: _.get(addressList, 'main_office_region_code'),
  });

  const [mainOfficeProvince, setMainOfficeProvince] = useState({
    label: _.get(addressList, 'main_office_province_name'),
    value: _.get(addressList, 'main_office_province_code'),
  });

  const [mainOfficeMunicipality, setMainOfficeMunicipality] = useState({
    label: _.get(addressList, 'main_office_municipality_name'),
    value: _.get(addressList, 'main_office_municipality_code'),
  });

  const [mainOfficeBarangay, setMainOfficeBarangay] = useState({
    label: _.get(addressList, 'main_office_barangay_name'),
    value: _.get(addressList, 'main_office_barangay_code'),
  });

  useEffect(() => {
    getRegionsList();
  }, []);

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(addressList, 'main_office_region_code') || _.get(addressListPrevious, 'main_office_region_code'),
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      region_code: _.get(addressList, 'main_office_region_code') || _.get(addressListPrevious, 'main_office_region_code'),
      province_code: _.get(addressList, 'main_office_province_code') || _.get(addressListPrevious, 'main_office_province_code'),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      region_code: _.get(addressList, 'main_office_region_code') || _.get(addressListPrevious, 'main_office_region_code'),
      province_code: _.get(addressList, 'main_office_province_code') || _.get(addressListPrevious, 'main_office_province_code'),
      municipality_code: _.get(addressList, 'main_office_municipality_code') || _.get(addressListPrevious, 'main_office_municipality_code'),
      display_all: 1
    });
  }, []);

  // const calculationDetails = _.get(
  //   updateList,
  //   'included.bplsApplication.attributes.calculation_details'
  // );

  const handleOnSubmit = e => {
    e.preventDefault();
    if (_.get(formData, 'trade_name') === '' || _.get(formData, 'incharge_middle_name') === '' || _.get(formData, 'incharge_suffix_name') === '' || _.get(formData, 'owners_gender') === '') {
      Object.keys(formData).forEach(key => {
        if ((formData[key] === undefined || formData[key] === null || formData[key] === false || formData[key] === "[]")) {
          delete formData[key];
        }
      });
    } else {
      Object.keys(formData).forEach(key => {
        if ((formData[key] === '' || formData[key] === undefined || formData[key] === null || formData[key] === false || formData[key] === "[]")) {
          delete formData[key];
        }
      });
    }

    let res = [];

    if (_.get(formData, 'activities').length > 0) {
      res = _.get(formData, 'activities').map(x => {
        if (x.details !== undefined) {
          Object.keys(x.details).forEach((key) => {
            // if (typeof (x.details[key]) !== 'string') {
              x.details[key] = x.details[key].replace(/,/g, "");
            // }
          });
        }
        return x;
      })
    }

    let existing_res = _.get(formData, 'existing_activities');

    if (_.get(formData, 'existing_activities').length > 0) {
      existing_res = _.get(formData, 'existing_activities').map(x => {
        if (x.details !== undefined) {
          Object.keys(x.details).forEach((key) => {
            // if (typeof (x.details[key]) !== 'string') {
              x.details[key] = x.details[key].toString().replace(/,/g, "");
            // }
          });
        }
        return x;
      })
    }

    const args = {
      ...formData,
      activities: res,
      existing_activities: existing_res
    }

    return changeApplication(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);

      return history.push(`/bpls/applications/change/${id}`);
    });
  };

  const handleChange = key => data => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      // const business = _.get(updateList, 'included.bplsChangeRequests.attributes');

      // const bplsActivities = _.get(updateList, "included.bplsChangeRequests.attributes.activities");
      // const bplsExistingActivities = _.get(updateList, "included.bplsChangeRequests.attributes.existing_activities");

      setFormData({
        ...formData,
        area: _.get(business, 'area'),
        base_line: _.get(business, 'base_line'),

        no_of_male_employees: _.get(business, 'no_of_male_employees'),
        no_of_female_employees: _.get(business, 'no_of_female_employees'),
        no_of_employees: _.get(business, 'no_of_employees'),
        no_of_employees_residing_manila: _.get(business, 'no_of_employees_residing_manila'),

        // no_of_vehicles: _.get(business, 'no_of_vehicles'),
        no_of_van: _.get(business, 'no_of_van'),
        no_of_truck: _.get(business, 'no_of_truck'),
        no_of_motorcycle: _.get(business, 'no_of_motorcycle'),

        region_code: _.get(business, 'region_code'),
        province_code: _.get(business, 'province_code'),
        municipality_code: _.get(business, 'municipality_code'),
        barangay_code: _.get(business, 'barangay_code'),
        street: _.get(business, 'street'),
        zip_code: _.get(business, 'zip_code'),
        location_owned: _.get(business, 'location_owned'),
        with_tax_incentives: !_.isEmpty(
          _.get(business, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(business, 'tdn_no'),
        pin_no: _.get(business, 'pin_no'),
        tax_incentives_attachment_url: _.get(
          business,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(business, 'kind_of_ownership'),
        owners_gender: _.get(business, 'owners_gender'),
        tin_no: _.get(business, 'tin_no'),
        // dti_no: _.get(business, 'dti_no'),
        sec_no: _.get(business, 'sec_no'),
        // cda_no: _.get(business, 'cda_no'),
        monthly_rental: _.get(business, 'monthly_rental'),
        business_name: _.get(business, 'business_name'),
        trade_name: _.get(business, 'trade_name'),
        lessor_name: _.get(business, 'lessor_name'),
        cellphone_no: _.get(business, 'cellphone_no'),
        telephone_no: _.get(business, 'telephone_no'),
        email_address: _.get(business, 'email_address'),
        nationality: _.get(business, 'nationality'),
        incharge_last_name: _.get(business, 'incharge_last_name'),
        incharge_first_name: _.get(business, 'incharge_first_name'),
        incharge_middle_name: _.get(business, 'incharge_middle_name'),
        incharge_suffix_name: _.get(business, 'incharge_suffix_name'),
        main_office_region_code:
          _.get(business, 'main_office_region_code'),
        main_office_province_code:
          _.get(business, 'main_office_province_code'),
        main_office_municipality_code:
          _.get(business, 'main_office_municipality_code'),
        main_office_barangay_code:
          _.get(business, 'main_office_barangay_code'),
        main_office_street: _.get(business, 'main_office_street'),
        main_office_zip_code: _.get(business, 'main_office_zip_code'),
        activity_type: _.get(business, 'activity_type'),
        pinned_geolocation:
          _.get(business, 'pinned_geolocation'),
        is_validated: _.get(business, 'is_validated'),
        veterinary_fee_id: _.get(business, 'veterinary_fee_id'),
        activities: bplsActivities,
        existing_activities: bplsExistingActivities
      });

      setFormDataPrevious({
        ...formDataPrevious,
        area: _.get(businessPrevious, 'area'),
        base_line: _.get(businessPrevious, 'base_line'),

        no_of_male_employees: _.get(businessPrevious, 'no_of_male_employees'),
        no_of_female_employees: _.get(businessPrevious, 'no_of_female_employees'),
        no_of_employees: _.get(businessPrevious, 'no_of_employees'),
        no_of_employees_residing_manila:
          _.get(businessPrevious, 'no_of_employees_residing_manila'),

        // no_of_vehicles: _.get(businessPrevious, 'no_of_vehicles'),
        no_of_van: _.get(businessPrevious, 'no_of_van'),
        no_of_truck: _.get(businessPrevious, 'no_of_truck'),
        no_of_motorcycle: _.get(businessPrevious, 'no_of_motorcycle'),

        region_code: _.get(businessPrevious, 'region_code'),
        province_code: _.get(businessPrevious, 'province_code'),
        municipality_code: _.get(businessPrevious, 'municipality_code'),
        barangay_code: _.get(businessPrevious, 'barangay_code'),
        street: _.get(businessPrevious, 'street'),
        zip_code: _.get(businessPrevious, 'zip_code'),
        location_owned: _.get(businessPrevious, 'location_owned'),
        with_tax_incentives: !_.isEmpty(
          _.get(businessPrevious, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(businessPrevious, 'tdn_no'),
        pin_no: _.get(businessPrevious, 'pin_no'),
        tax_incentives_attachment_url: _.get(
          businessPrevious,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(businessPrevious, 'kind_of_ownership'),
        owners_gender: _.get(businessPrevious, 'owners_gender'),
        tin_no: _.get(businessPrevious, 'tin_no'),
        // dti_no: _.get(businessPrevious, 'dti_no'),
        sec_no: _.get(businessPrevious, 'sec_no'),
        // cda_no: _.get(businessPrevious, 'cda_no'),
        monthly_rental: _.get(businessPrevious, 'monthly_rental'),
        business_name: _.get(businessPrevious, 'business_name'),
        trade_name: _.get(businessPrevious, 'trade_name'),
        lessor_name: _.get(businessPrevious, 'lessor_name'),
        cellphone_no: _.get(businessPrevious, 'cellphone_no'),
        telephone_no: _.get(businessPrevious, 'telephone_no'),
        email_address: _.get(businessPrevious, 'email_address'),
        nationality: _.get(businessPrevious, 'nationality'),
        incharge_last_name: _.get(businessPrevious, 'incharge_last_name'),
        incharge_first_name: _.get(businessPrevious, 'incharge_first_name'),
        incharge_middle_name: _.get(businessPrevious, 'incharge_middle_name'),
        incharge_suffix_name: _.get(businessPrevious, 'incharge_suffix_name'),
        main_office_region_code:
          _.get(businessPrevious, 'main_office_region_code'),
        main_office_province_code:
          _.get(businessPrevious, 'main_office_province_code'),
        main_office_municipality_code:
          _.get(businessPrevious, 'main_office_municipality_code'),
        main_office_barangay_code:
          _.get(businessPrevious, 'main_office_barangay_code'),
        main_office_street: _.get(businessPrevious, 'main_office_street'),
        main_office_zip_code: _.get(businessPrevious, 'main_office_zip_code'),
        activity_type: _.get(businessPrevious, 'activity_type'),
        pinned_geolocation:
          _.get(businessPrevious, 'pinned_geolocation'),
        is_validated: _.get(businessPrevious, 'is_validated'),
        veterinary_fee_id: _.get(businessPrevious, 'veterinary_fee_id'),
        activities: bplsActivitiesPrevious
      });
    }
  }, []);

  // useEffect(() => {
  //   if (!_.isEmpty(calculationDetails)) {
  //     setFormDataCalculation({
  //       ...formDataCalculation,
  //       ...calculationDetails,
  //     });
  //   }
  // }, []);

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleMainOfficeRegionSelect = e => {
    setMainOfficeRegion(e);
    setFormData({
      ...formData,
      main_office_region_code: e.value,
    });
    getProvinceList({ region_code: e.value });
  };

  const handleMainOfficeProvinceSelect = e => {
    setMainOfficeProvince(e);
    setFormData({
      ...formData,
      main_office_province_code: e.value,
    });
    getMunicipalityList({
      region_code: _.get(addressList, 'main_office_region_code') || _.get(addressListPrevious, 'main_office_region_code'),
      province_code: e.value
    });
  };

  const handleMainOfficeMunicipalitySelect = e => {
    setMainOfficeMunicipality(e);
    setFormData({
      ...formData,
      main_office_municipality_code: e.value,
      main_office_barangay_code: '',
    });
    setMainOfficeBarangay({});
    getBarangayList(
      {
        region_code: _.get(addressList, 'main_office_region_code') || _.get(addressListPrevious, 'main_office_region_code'),
        province_code: _.get(addressList, 'main_office_province_code') || _.get(addressListPrevious, 'main_office_province_code'),
        municipality_code: e.value,
        display_all: 1
      }
    );
  };

  const handleMainOfficeBarangaySelect = e => {
    setMainOfficeBarangay(e);
    setFormData({
      ...formData,
      main_office_barangay_code: e.value,
    });
  };

  // const onChangeRadio = e => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: +e.target.value,
  //   });
  // };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const handleOnChange = key => e => {
  //   setFormData({
  //     ...formData,
  //     [key]: e.target.value,
  //   });
  // };

  // const onChangeCalculationDetails = e => {
  //   setFormDataCalculation({
  //     ...formDataCalculation,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  // const disableOwnersGender = data => {
  //   if (_.isEmpty(data)) {
  //     return true;
  //   }
  //   if (['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(data) <= -1) {
  //     return false;
  //   }
  //   return true;
  // };

  const handleOnChangeSelectKind = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
      owners_gender: '',
    });
  };

  const handleOnChangeSelect = key => e => {

    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleOnChangeRadio = e => {
    if (e.target.value !== 'others') {
      setFormData({
        ...formData,
        activity_type: e.target.value,
        activity_type_others: '',
      });
    }

    setFormData({
      ...formData,
      activity_type: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  // console.log(formData, 'formData');
  // console.log(formDataPrevious, 'formDataPrevious');

  // useEffect(() => {
  //   validateFormCalculation.validate();
  // }, []);

  // const onChangePhoto = key => data => {
  //   setFormData({
  //     ...formData,
  //     [key]: data.cdnUrl,
  //   });
  // };

  // // vet reg filter dropdown
  // const vetRegistrationListOption =
  //   vetRegistrationList.map(item => ({
  //     label: _.get(item, 'attributes.veterinary_registration'),
  //     value: _.get(item, 'id'),
  //   })) || '';
  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {/* business form change */}
        {(!_.isEmpty(_.get(business, 'business_name')) ||
          ((_.get(business, 'trade_name') !== null && !_.isEmpty(_.get(business, 'trade_name'))) || _.get(business, 'trade_name') === "") ||
          (_.get(business, 'owners_gender') !== null || !_.isEmpty(_.get(business, 'owners_gender'))) ||
          !_.isEmpty(_.get(business, 'kind_of_ownership')) ||
          !_.isEmpty(_.get(business, 'incharge_last_name')) ||
          !_.isEmpty(_.get(business, 'incharge_first_name')) ||
          ((_.get(business, 'incharge_middle_name') !== null && !_.isEmpty(_.get(business, 'incharge_middle_name'))) || _.get(business, 'incharge_middle_name') === "") ||
          ((_.get(business, 'incharge_suffix_name') !== null && !_.isEmpty(_.get(business, 'incharge_suffix_name'))) || _.get(business, 'incharge_suffix_name') === "")
        ) &&
          (
            <>
              <Section title="Business Information and Registration">
                <div className="row">
                  <div className="col-6">
                    <div className="row ml-auto text-primary font-weight-bold mb-2">
                      Previous Information
                    </div>
                    <div className="row mt-2">
                      {!_.isEmpty(_.get(business, 'kind_of_ownership')) && (
                        <>
                          <div className="col-12 form-group">
                            <label htmlFor="last_name" className="form-label mb-0">
                              Business Type
                            </label>
                            <Select
                              name="kind_of_ownership"
                              placeholder="Select Business Type"
                              onChange={handleOnChangeSelect('kind_of_ownership')}
                              options={c.KIND_OF_OWNERSHIP}
                              value={
                                c.KIND_OF_OWNERSHIP.find(
                                  item =>
                                    _.get(formDataPrevious, 'kind_of_ownership') ===
                                    _.get(item, 'value')
                                ) || ''
                              }
                              isDisabled
                            />
                          </div>
                        </>
                      )}
                      {/* {((_.get(formData, 'owners_gender') !== null || !_.isEmpty(_.get(formData, 'owners_gender'))) && formData.kind_of_ownership !== null) && (
                        (formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                          formData.kind_of_ownership === 'SOLE PROPRIETORSHIP') && (
                          <div className="col-12 form-group">
                            <label htmlFor="last_name" className="form-label mb-0">
                              Owners Gender {validateForm.renderMessage('owners_gender')}
                            </label>
                            <Select
                              name="owners_gender"
                              placeholder="Select Module"
                              onChange={handleOnChangeSelect('owners_gender')}
                              options={c.OWNERS_GENDER}
                              value={
                                c.OWNERS_GENDER.find(
                                  item =>
                                    _.get(formDataPrevious, 'owners_gender') ===
                                    _.get(item, 'value')
                                ) || ''
                              }
                              isDisabled
                            />
                          </div>
                        )
                      )} */}
                      {((_.get(business, 'owners_gender') !== null || !_.isEmpty(_.get(business, 'owners_gender'))) && business.kind_of_ownership === null) && (
                        // (formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                        //   formData.kind_of_ownership === 'SOLE PROPRIETORSHIP') && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Owners Gender {validateForm.renderMessage('owners_gender')}
                          </label>
                          <Select
                            name="owners_gender"
                            placeholder="Select Gender"
                            onChange={handleOnChangeSelect('owners_gender')}
                            options={c.OWNERS_GENDER}
                            value={
                              c.OWNERS_GENDER.find(
                                item =>
                                  _.get(formDataPrevious, 'owners_gender') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                            isDisabled
                          />
                        </div>
                        // )
                      )}
                      {((_.get(business, 'owners_gender') === "" || _.get(business, 'owners_gender') !== "") && business.kind_of_ownership !== null) && (
                        // (formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                        //   formData.kind_of_ownership === 'SOLE PROPRIETORSHIP') && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Owners Gender
                          </label>
                          <Select
                            name="owners_gender"
                            placeholder="Select Gender"
                            onChange={handleOnChangeSelect('owners_gender')}
                            options={c.OWNERS_GENDER}
                            value={
                              c.OWNERS_GENDER.find(
                                item =>
                                  _.get(formDataPrevious, 'owners_gender') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                            isDisabled
                          />
                        </div>
                        // )
                      )}
                      {!_.isEmpty(_.get(business, 'business_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Business Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="business_name"
                            onChange={handleOnChange}
                            value={_.get(formDataPrevious, 'business_name') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {(_.get(business, 'trade_name') !== null || _.get(business, 'trade_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Trade Name / Franchise (If Applicable) :
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="trade_name"
                            onChange={handleOnChange}
                            value={_.get(formDataPrevious, 'trade_name') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {!_.isEmpty(_.get(business, 'incharge_last_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Last Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_last_name"
                            onChange={handleOnChange}
                            value={_.get(formDataPrevious, 'incharge_last_name') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {!_.isEmpty(_.get(business, 'incharge_first_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            First Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_first_name"
                            onChange={handleOnChange}
                            value={_.get(formDataPrevious, 'incharge_first_name') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {(_.get(business, 'incharge_middle_name') !== null || _.get(business, 'incharge_middle_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Middle Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_middle_name"
                            onChange={handleOnChange}
                            value={_.get(formDataPrevious, 'incharge_middle_name') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {(_.get(business, 'incharge_suffix_name') !== null || _.get(business, 'incharge_suffix_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Suffix
                          </label>
                          <Select
                            name="incharge_suffix_name"
                            placeholder="Select Suffix Name"
                            onChange={handleOnChangeSelect('incharge_suffix_name')}
                            options={c.EXTENSION_NAMES}
                            value={
                              c.EXTENSION_NAMES.find(
                                item =>
                                  _.get(formDataPrevious, 'incharge_suffix_name') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                            isDisabled
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row ml-auto text-primary font-weight-bold mb-2">
                      Request Changes
                    </div>
                    <div className="row mt-2">
                      {!_.isEmpty(_.get(business, 'kind_of_ownership')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Business Type: {validateForm.renderMessage('kind_of_ownership')}
                          </label>
                          <Select
                            name="kind_of_ownership"
                            placeholder="Select Business Type"
                            onChange={handleOnChangeSelectKind('kind_of_ownership')}
                            options={c.KIND_OF_OWNERSHIP}
                            value={
                              c.KIND_OF_OWNERSHIP.find(
                                item =>
                                  _.get(formData, 'kind_of_ownership') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                          />
                        </div>
                      )}
                      {/* {((_.get(formData, 'owners_gender') !== null || !_.isEmpty(_.get(formData, 'owners_gender'))) && formData.kind_of_ownership !== null) && (
                        (formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                          formData.kind_of_ownership === 'SOLE PROPRIETORSHIP') && (
                          <div className="col-12 form-group">
                            <label htmlFor="last_name" className="form-label mb-0">
                              Owners Gender {validateForm.renderMessage('owners_gender')}
                              {["PARTNERSHIP", "CORPORATION", "COOPERATIVE"].indexOf(_.get(formData, "kind_of_ownership")) > -1 ? " (Not Applicable)" : ""}
                            </label>
                            <Select
                              name="owners_gender"
                              placeholder="Select Module"
                              onChange={handleOnChangeSelect('owners_gender')}
                              options={c.OWNERS_GENDER}
                              value={
                                c.OWNERS_GENDER.find(
                                  item =>
                                    _.get(formData, 'owners_gender') ===
                                    _.get(item, 'value')
                                ) || ''
                              }
                            />
                          </div>
                        )
                      )} */}
                      {((_.get(business, 'owners_gender') !== null || !_.isEmpty(_.get(business, 'owners_gender'))) && business.kind_of_ownership === null) && (
                        // (formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                        //   formData.kind_of_ownership === 'SOLE PROPRIETORSHIP') && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Owners Gender {validateForm.renderMessage('owners_gender')}
                            {["PARTNERSHIP", "CORPORATION", "COOPERATIVE"].indexOf(_.get(formData, "kind_of_ownership")) > -1 ? " (Not Applicable)" : ""}
                          </label>
                          <Select
                            name="owners_gender"
                            placeholder="Select Gender"
                            onChange={handleOnChangeSelect('owners_gender')}
                            options={c.OWNERS_GENDER}
                            value={
                              c.OWNERS_GENDER.find(
                                item =>
                                  _.get(formData, 'owners_gender') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                          />
                        </div>
                        // )
                      )}
                      {((_.get(business, 'owners_gender') === "" || _.get(business, 'owners_gender') !== "") && business.kind_of_ownership !== null) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Owners Gender {validateForm.renderMessage('owners_gender')}
                            {["PARTNERSHIP", "CORPORATION", "COOPERATIVE"].indexOf(_.get(formData, "kind_of_ownership")) > -1 ? " (Not Applicable)" : ""}
                          </label>
                          <Select
                            name="owners_gender"
                            isDisabled={["PARTNERSHIP", "CORPORATION", "COOPERATIVE"].indexOf(_.get(formData, "kind_of_ownership")) > -1}
                            placeholder="Select Gender"
                            onChange={handleOnChangeSelect('owners_gender')}
                            options={c.OWNERS_GENDER}
                            value={
                              c.OWNERS_GENDER.find(
                                item =>
                                  _.get(formData, 'owners_gender') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                          />
                        </div>
                      )}
                      {!_.isEmpty(_.get(business, 'business_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Business Name: {validateForm.renderMessage('business_name')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="business_name"
                            onChange={handleOnChange}
                            value={_.get(formData, 'business_name') || ''}
                          />
                        </div>
                      )}
                      {(_.get(business, 'trade_name') !== null || _.get(business, 'trade_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Trade Name / Franchise (If Applicable) :
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="trade_name"
                            onChange={handleOnChange}
                            value={_.get(formData, 'trade_name') || ''}
                          />
                        </div>
                      )}
                      {!_.isEmpty(_.get(business, 'incharge_last_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Last Name {validateForm.renderMessage('incharge_last_name')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_last_name"
                            onChange={handleOnChange}
                            value={_.get(formData, 'incharge_last_name') || ''}
                          />
                        </div>
                      )}
                      {!_.isEmpty(_.get(business, 'incharge_first_name')) && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            First Name {validateForm.renderMessage('incharge_first_name')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_first_name"
                            onChange={handleOnChange}
                            value={_.get(formData, 'incharge_first_name') || ''}
                          />
                        </div>
                      )}
                      {(_.get(business, 'incharge_middle_name') !== null || _.get(business, 'incharge_middle_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Middle Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="incharge_middle_name"
                            onChange={handleOnChange}
                            value={_.get(formData, 'incharge_middle_name') || ''}
                          />
                        </div>
                      )}
                      {(_.get(business, 'incharge_suffix_name') !== null || _.get(business, 'incharge_suffix_name') === "") && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Suffix
                          </label>
                          <Select
                            name="incharge_suffix_name"
                            placeholder="Select Suffix"
                            onChange={handleOnChangeSelect('incharge_suffix_name')}
                            options={c.EXTENSION_NAMES}
                            value={
                              c.EXTENSION_NAMES.find(
                                item =>
                                  _.get(formData, 'incharge_suffix_name') ===
                                  _.get(item, 'value')
                              ) || ''
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Section>
            </>
          )}

        {/* Business address */}
        {!_.isEmpty(_.get(business, 'main_office_region_code')) || !_.isEmpty(_.get(business, 'main_office_municipality_code'))
          || !_.isEmpty(_.get(business, 'main_office_province_code')) || !_.isEmpty(_.get(business, 'main_office_barangay_code'))
          || !_.isEmpty(_.get(business, 'main_office_street')) || !_.isEmpty(_.get(business, 'main_office_zip_code')) || !_.isEmpty(_.get(business, 'pinned_geolocation'))
          ? (
            <Section title="Business Address">
              <div className="row p-2">
                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Previous Information
                  </div>
                  <div className="row p-2">
                    {!_.isEmpty(_.get(business, 'main_office_region_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Region
                        </label>
                        <div>
                          <Select
                            options={createDropdown(regionsList)}
                            styles={customStyle}
                            placeholder="Select Region"
                            value={mainOfficeRegionPrevious}
                            onChange={e => {
                              handleMainOfficeRegionSelect(e);
                            }}
                            isDisabled
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_province_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Province
                        </label>
                        <div>
                          <Select
                            options={createDropdown(provinceList)}
                            styles={customStyle}
                            placeholder="Select Province"
                            value={mainOfficeProvincePrevious}
                            onChange={e => {
                              handleMainOfficeProvinceSelect(e);
                            }}
                            isDisabled
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_municipality_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Municipality
                        </label>
                        <div>
                          <Select
                            options={createDropdown(municipalityList)}
                            styles={customStyle}
                            placeholder="Select Municipality"
                            value={mainOfficeMunicipalityPrevious}
                            onChange={e => {
                              handleMainOfficeMunicipalitySelect(e);
                            }}
                            isDisabled
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_barangay_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Barangay
                        </label>
                        <div>
                          <Select
                            options={createDropdown(barangayList)}
                            styles={customStyle}
                            placeholder="Select Barangay"
                            value={mainOfficeBarangayPrevious}
                            onChange={e => {
                              handleMainOfficeBarangaySelect(e);
                            }}
                            isDisabled
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_street')) && (
                      <div className="col-12 form-group">
                        <label htmlFor="last_name" className="form-label mb-0">
                          Unit/Room Number/Floor, Building Name, House Number, Street
                          Name
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="street"
                          onChange={onChange}
                          value={_.get(formDataPrevious, 'main_office_street') || ''}
                          disabled
                        />
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_zip_code')) && (
                      <div className="col-12 form-group">
                        <label htmlFor="last_name" className="form-label mb-0">
                          Zip Code
                        </label>
                        <input
                          className="form-control"
                          mask="9999"
                          type="text"
                          name="zip_code"
                          onChange={onChange}
                          value={_.get(formDataPrevious, 'main_office_zip_code') || ''}
                          disabled
                        />
                      </div>
                    )}
                  </div>
                  {!_.isEmpty(_.get(business, 'pinned_geolocation')) && (
                    <PreviousLocation
                      pinLocation={
                        _.get(
                          formDataPrevious,
                          'pinned_geolocation'
                        ) || ''
                      }
                    />
                  )}
                </div>
                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Request Changes
                  </div>
                  <div className="row p-2">
                    {!_.isEmpty(_.get(business, 'main_office_region_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Region
                          {validateForm.renderMessage('main_office_region_code')}
                        </label>
                        <div>
                          <Select
                            options={createDropdown(regionsList)}
                            styles={customStyle}
                            placeholder="Select Region"
                            value={mainOfficeRegion}
                            onChange={e => {
                              handleMainOfficeRegionSelect(e);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_province_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Province
                          {validateForm.renderMessage('main_office_province_code')}
                        </label>
                        <div>
                          <Select
                            options={createDropdown(provinceList)}
                            styles={customStyle}
                            placeholder="Select Province"
                            value={mainOfficeProvince}
                            onChange={e => {
                              handleMainOfficeProvinceSelect(e);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_municipality_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Municipality
                          {validateForm.renderMessage('main_office_municipality_code')}
                        </label>
                        <div>
                          <Select
                            options={createDropdown(municipalityList)}
                            styles={customStyle}
                            placeholder="Select Municipality"
                            value={mainOfficeMunicipality}
                            onChange={e => {
                              handleMainOfficeMunicipalitySelect(e);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_barangay_code')) && (
                      <div className="col-12 form-group">
                        <label className="form-label mb-0">
                          Select Barangay
                          {validateForm.renderMessage('main_office_barangay_code')}
                        </label>
                        <div>
                          <Select
                            options={createDropdown(barangayList)}
                            styles={customStyle}
                            placeholder="Select Barangay"
                            value={mainOfficeBarangay}
                            onChange={e => {
                              handleMainOfficeBarangaySelect(e);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_street')) && (
                      <div className="col-12 form-group">
                        <label htmlFor="main_office_street" className="form-label mb-0">
                          Unit/Room Number/Floor, Building Name, House Number, Street
                          Name
                          {validateForm.renderMessage('main_office_street')}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="main_office_street"
                          onChange={handleOnChange}
                          value={_.get(formData, 'main_office_street') || ''}
                        />
                      </div>
                    )}
                    {!_.isEmpty(_.get(business, 'main_office_zip_code')) && (
                      <div className="col-12 form-group">
                        <label htmlFor="last_name" className="form-label mb-0">
                          Zip Code
                          {validateForm.renderMessage('main_office_zip_code')}
                        </label>
                        <InputMask
                          className="form-control"
                          placeholder="Enter Zip Code"
                          mask="9999"
                          type="text"
                          name="main_office_zip_code"
                          onChange={onChange}
                          value={_.get(formData, 'main_office_zip_code') || ''}
                        />
                      </div>
                    )}
                  </div>
                  {!_.isEmpty(_.get(business, 'pinned_geolocation')) && (
                    <UpdateLocation
                      formData={formData}
                      setFormData={setFormData}
                    />
                  )}
                </div>
              </div>
            </Section>
          ) : (
            ''
          )}

        {/* business operation */}
        {(_.get(business, 'area') !== null || _.get(business, 'no_of_employees_residing_manila') !== null || _.get(business, 'no_of_male_employees') !== null
          || _.get(business, 'no_of_female_employees') !== null || _.get(business, 'no_of_van') !== null
          || _.get(business, 'no_of_truck') !== null || _.get(business, 'no_of_motorcycle') !== null) && (
            <>
              <Section title="Business Operation">
                <div className="row">
                  <div className="col-6">
                    <div className="row ml-auto text-primary font-weight-bold mb-2">
                      Previous Information
                    </div>
                    <div className="row">
                      {_.get(business, 'area') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Business Area/Total Floor Area (sq.m):
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="area"
                            value={_.get(formDataPrevious, 'area') || ''}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_employees_residing_manila') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Employees risiding within Manila
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_employees_residing_manila"
                            value={_.get(formDataPrevious, 'no_of_employees_residing_manila') || 0}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_male_employees') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Total Number of Male Employees
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_male_employees"
                            value={_.get(formDataPrevious, 'no_of_male_employees') || 0}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_female_employees') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Total Number of Female Employees
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_female_employees"
                            value={_.get(formDataPrevious, 'no_of_female_employees') || 0}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_van') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Van Delivery Vehicle: (if applicable)
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_van"
                            value={_.get(formDataPrevious, 'no_of_van') || 0}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_truck') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Truck Delivery Vehicle: (if applicable)
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_truck"
                            value={_.get(formDataPrevious, 'no_of_truck') || 0}
                            disabled
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_motorcycle') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Motorcycle Delivery Vehicle: (if applicable)
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="no_of_motorcycle"
                            value={_.get(formDataPrevious, 'no_of_motorcycle') || 0}
                            disabled
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row ml-auto text-primary font-weight-bold mb-2">
                      Request Changes
                    </div>
                    <div className="row mt-2">
                      {_.get(business, 'area') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Business Area/Total Floor Area (sq.m):{' '}
                            {validateForm.renderMessage('area')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="area"
                            onChange={handleOnChange}
                            value={_.get(formData, 'area')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_employees_residing_manila') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Employees residing within Manila:{' '}
                            {validateForm.renderMessage('no_of_employees_residing_manila')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_employees_residing_manila"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_employees_residing_manila')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_male_employees') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Total Number of Male Employees:{' '}
                            {validateForm.renderMessage('no_of_male_employees')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_male_employees"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_male_employees')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_female_employees') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Total Number of Female Employees:{' '}
                            {validateForm.renderMessage('no_of_female_employees')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_female_employees"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_female_employees')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_van') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Van Delivery Vehicle: (if applicable):{' '}
                            {validateForm.renderMessage('no_of_van')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_van"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_van')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_truck') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Truck Delivery Vehicle: (if applicable):{' '}
                            {validateForm.renderMessage('no_of_truck')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_truck"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_truck')}
                          />
                        </div>
                      )}
                      {_.get(business, 'no_of_motorcycle') !== null && (
                        <div className="col-12 form-group">
                          <label htmlFor="last_name" className="form-label mb-0">
                            Number of Motorcycle Delivery Vehicle: (if applicable):{' '}
                            {validateForm.renderMessage('no_of_motorcycle')}
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            name="no_of_motorcycle"
                            onChange={handleOnChange}
                            value={_.get(formData, 'no_of_motorcycle')}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Section>
            </>
          )}

        {/* Business Activities */}
        {((bplsActivities || []).length > 0 || (bplsExistingActivities || []).length > 0 || !_.isEmpty(_.get(business, 'activity_type'))) && (
          <>
            <Section title="Business Activities">
              {(_.get(business, 'activity_type') !== null) && (
                <>
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Previous Information
                  </div>
                  <div className="container-fluid">
                    <div className="col-6 form-group">
                      <label htmlFor="last_name" className="form-label mb-0">
                        Activity Type
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="activity_type"
                        value={_.get(formDataPrevious, 'activity_type')}
                        disabled
                      />
                      {_.get(formDataPrevious, 'activity_type') === 'OTHERS' && (
                        <input
                          className="form-control"
                          type="text"
                          name="activity_type_others"
                          value={_.get(formDataPrevious, 'activity_type_others')}
                          disabled
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
              {/* {(_.get(formData, 'activities') === "[]" ? [] : _.get(formData, 'activities')).length > 0 && (
                <>
                  <BusinessActivityList
                    activityList={_.get(formData, 'activities') === "[]" ? [] : _.get(formDataPrevious, 'activities')}
                    businessId={id}
                    pathName={history.location.pathname}
                    type="VIEW"
                  />
                </>
              )} */}
              {(_.get(business, 'activity_type') !== null) && (
                <>
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Request Changes
                  </div>
                  <div className="container-fluid">
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={_.get(formData, 'activity_type') === 'MAIN OFFICE'}
                        value="MAIN OFFICE"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Main Office</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                        value="BRANCH OFFICE"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Branch Office</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                        value="BRANCH OFFICE"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Branch Office</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={
                          _.get(formData, 'activity_type') === 'ADMIN OFFICE ONLY'
                        }
                        value="ADMIN OFFICE ONLY"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Admin Office Only</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={_.get(formData, 'activity_type') === 'WAREHOUSE'}
                        value="WAREHOUSE"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Warehouse</label>
                    </div>
                  </div>
                  <div className="container-fluid">
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="activity_type"
                        onChange={handleOnChangeRadio}
                        checked={_.get(formData, 'activity_type') === 'OTHERS'}
                        value="OTHERS"
                      />
                      <label className="form-check-label business-activity-label ml-3" htmlFor="inlineCheckbox1">Others</label>
                    </div>
                    <input
                      className="col-4 custom-input"
                      type="text"
                      name="activity_type_others"
                      onChange={handleOnChange}
                      placeholder="Pls specify"
                      value={_.get(formData, 'activity_type_others') || ''}
                    />
                  </div>
                </>
              )}
              {((bplsExistingActivities || []).length > 0) && (
                <>
                  <div className="d-flex align-items-center pt-2 pb-3">
                    <h3 className="font-weight-bolder my-2 mr-2 align-middle text-primary">
                      Update&nbsp;Activity
                    </h3>
                    <hr className="p-0 m-0 w-100 border border-4" />
                  </div>
                  <ExistingBusinessActivityList
                    value={_.get(formData, 'existing_activities') || []}
                    onChange={handleChange("existing_activities")}
                    previousActivity={_.get(formDataPrevious, 'activities') || []}
                  />
                </>
              )}
              {(bplsActivities || []).length > 0 && (
                <>
                  <div className="d-flex align-items-center pt-2">
                    <h3 className="font-weight-bolder mb-2 mt-2 mr-2 align-middle text-primary">
                      New&nbsp;Activity
                    </h3>
                    <hr className="p-0 m-0 w-100 border border-4" />
                  </div>
                  <NewBusinessActivityList
                    value={_.get(formData, 'activities') || []}
                    onChange={handleChange("activities")}
                  />
                </>
              )}
            </Section>
          </>
        )}
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Assess`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>

        </div>
      </form>
    </Modal.Body>
  );
}

ChangeRequestModal.propTypes = {
  changeApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,

  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,

  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  // vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],

  // vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeRequestModal);
